import styled from 'styled-components';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { BiChevronRight } from 'react-icons/bi';

import DashboardLayout from '../layouts/dashboard';
import { CredusText } from 'ui';

const TestManagement = () => {
  const location = useLocation();
  const path = location.pathname;
  const subPath = path.slice(path.lastIndexOf('/') + 1);

  const getSubPath = (subPath: string) => {
    switch (subPath) {
      case 'candidate-upload':
        return 'Candidates';
      case 'test-upload':
        return 'Tests';
      case 'report':
        return 'Reports';
      default:
        return 'Candidates';
    }
  };
  return (
    <DashboardLayout
      name="Test"
      breadCrumbs={
        <BreadCrumb>
          <Link to="/dashboard" className="breadcrumb-link">
            <CredusText color={'#7a7a7a'} size="sm">
              Dashboard
            </CredusText>
          </Link>
          <BiChevronRight color={'#7a7a7a'} />
          <Link to="/test-management" className='breadcrumb-link'>
            <CredusText color={'#7a7a7a'} size="sm">
              Test Management
            </CredusText>
          </Link>
          <BiChevronRight color={'#7a7a7a'} />
          <CredusText color={'#7a7a7a'} size="sm">
            {getSubPath(subPath)}
          </CredusText>
        </BreadCrumb>
      }
    >
      <Outlet />
    </DashboardLayout>
  );
};

export default TestManagement;

export const BreadCrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;
